/** priority bounds enforced by CreateBonusDto/UpdateBonusDto in the bonus engine */
export const MIN_BONUS_PRIORITY = 0
export const MAX_BONUS_PRIORITY = 100
export const DEFAULT_BONUS_PRIORITY = 0
